<h1>2FA bulk update</h1> 
<form [formGroup]="uploadForm" (ngSubmit)="upload()">
  <div class="row">
    <div class="col-12 col-sm-8 col-lg-4">
      <div class="mt-2"><span> Select a formatted CSV file (max 300 users) to bulk update 2FA. </span>
        <a class="ml-2" [routerLink]="[]" (click)="downloadMfaTemplate()">Download the template file</a>
      </div>
    </div>
  </div>

  <div>
      <div class="row">
          <div class="col-12 col-sm-8 col-lg-4 my-3">
              <div class="form-group  input-required">
                  <input type="file" #file style="display: none" formControlName="fileUpload" required
                         (change)="onFileSelected()" />
                  <button type="button" class="btn btn-primary" [disabled]="isSupportUser || uploading" (click)="selectFile()">
                      Select File
                  </button>
                  {{fileName || "No file selected yet."}}
              </div>
              <small *ngIf="selectedFile && uploadForm.get('fileUpload').errors?.invalidFileType" class="text-danger">
                  Invalid file type. Please upload csv file.
              </small>
          </div>
      </div>

      <div class="row mt-3">
          <div class="col-12 col-sm-8 col-lg-4">
              <div>
                  <button type="submit" class=" btn btn-primary" [disabled]="!uploadForm.valid || status?.statusId==1">
                      Upload
                  </button>
                  <span class="ml-2" [ngClass]="statusClassIcon"></span><span class="ml-2" [ngClass]="statusClass">{{statusText}}</span>
                  <!--
                TODO: Conditionally display cancel button. May not be required in all cases.
                <button type="button" class="ml-3 btn btn-cancel" (click)="cancel()">
                  Cancel
                </button>-->
              </div>
          </div>
      </div>
  </div>
</form>
